/**
 * Chili Piper constants — the account, the loader URL, and the form-field mapping.
 *
 * ── DO NOT STRING-COMPARE thryvData.env ───────────────────────────────────────────────────────
 *
 * It is 'local' | 'staging' | 'live' (App\Support\Environment) — there is no "prod". Legacy's
 * `[ChiliPiperDS env="prod"]` is a shortcode attribute authored in page content, an unrelated
 * vocabulary using the same word. Comparing against "prod" never matches, which would have sent
 * production traffic to the sandbox. PHP derives the boolean; JS reads `thryvData.is_live`.
 */

/** True only on the live site. Missing or unexpected data fails safe to not-live. */
const isLive = () => window.thryvData?.is_live === true;

const Config = {
  /**
   * The CP tenant — the subdomain in every CP URL. Sandbox anywhere but live, so a booking from a
   * local machine cannot land in a real rep's calendar. Overridable per call; see index.js.
   */
  account: () => (isLive() ? "thryv" : "thryv-sandbox"),

  /*
   * NO DEFAULT ROUTER. A router decides which rep gets the meeting, and CP keeps separate ones per
   * audience and per environment — so a guess is a lead quietly sent to the wrong queue, which the
   * page cannot tell apart from success. book() and deploy() refuse without one. Which router a page
   * should use is resolved where the page is rendered (DemoShortcodes.php emits `data-router`).
   */

  loaderUrl: (account) => `https://${account}.chilipiper.com/concierge-js/cjs/concierge.js`,
};

export default Config;
